export const ADMIN_TOOLS_CHANGE_TRACKING = {
  applyPayments: {
    source: 'admin_tools.apply_payments',
    id: 21001,
  },
  applyShortPays: {
    source: 'admin_tools.apply_short_pays',
    id: 21002,
  },
  creditInsuranceReset: {
    source: 'admin_tools.credit_insurance_reset',
    id: 21003,
  },
  inactivateCarriers: {
    source: 'admin_tools.inactivate_carriers',
    id: 21004,
  },
  activateCarriers: {
    source: 'admin_tools.activate_carriers',
    id: 21005,
  },
  apply90DaysRetraction: {
    source: 'admin_tools.apply_90_days_retraction',
    id: 21006,
  },
  apply120DaysRetraction: {
    source: 'admin_tools.apply_120_days_retraction',
    id: 21007,
  },
  apply90DaysRefund: {
    source: 'admin_tools.apply_90_days_refund',
    id: 21008,
  },
  apply120DaysRefund: {
    source: 'admin_tools.apply_120_days_refund',
    id: 21009,
  },
  updateCarrierPaymentDate: {
    source: 'admin_tools.update_carrier_payment_date',
    id: 21010,
  },
  updateCustomerInvoiceDate: {
    source: 'admin_tools.update_customer_invoice_date',
    id: 21011,
  },
  markVendorsBilled: {
    source: 'admin_tools.mark_vendors_billed',
    id: 21012,
  },
} as const;
